import React, { useMemo } from 'react';
import { classNames } from '../tools/helpers';
import Logo from './Logo';

export default function Footer({ data, className }) {
    const splitDescription = useMemo(
        () => data?.footer_copyright?.description?.split('|') || [],
        [data],
    );

    const splitAdditionalServices = useMemo(
        () => data?.additional_services?.description?.split('|') || [],
        [data],
    );

    const links =
        splitAdditionalServices
            .map((str) => {
                const split = str.split('@');
                if (split.length >= 2) {
                    return {
                        title: split[0],
                        href: split[1],
                    };
                }
                return false;
            })
            .filter(Boolean);

    const contacts = [
        {
            linkUrl: data?.footer_map?.link_url,
            imageSrc: data?.footer_map?.image_src,
            imageAlt: data?.footer_map?.image_alt,
            description: data?.footer_map?.description,
        },
        {
            linkUrl: data?.footer_email?.link_url,
            imageSrc: data?.footer_email?.image_src,
            imageAlt: data?.footer_email?.image_alt,
            description: data?.footer_email?.description,
        },
    ];
    const socials = [
        {
            linkUrl: data?.footer_twitter?.link_url,
            imageSrc: data?.footer_twitter?.image_src,
            imageAlt: data?.footer_twitter?.image_alt,
        },
        {
            linkUrl: data?.footer_facebook?.link_url,
            imageSrc: data?.footer_facebook?.image_src,
            imageAlt: data?.footer_facebook?.image_alt,
        },
        {
            linkUrl: data?.footer_linkedin?.link_url,
            imageSrc: data?.footer_linkedin?.image_src,
            imageAlt: data?.footer_linkedin?.image_alt,
        },
        {
            linkUrl: data?.footer_instagram?.link_url,
            imageSrc: data?.footer_instagram?.image_src,
            imageAlt: data?.footer_instagram?.image_alt,
        },
    ];
    return (
        <div
            className={classNames(
                'flex flex-col-reverse gap-x-4 gap-y-8 justify-between text-white md:flex-row',
                className,
            )}
        >
            <div>
                <Logo />
                <p className={'m-0 mt-2 text-sm sm:mt-4 sm:leading-7 sm:text-base'}>
                    {splitDescription.length >= 1 && splitDescription[0]}{' '}
                    {new Date().getFullYear()}{' '}
                    {splitDescription.length >= 2 && splitDescription[1]}
                </p>
                <ul className={'flex gap-4 mt-4 sm:mt-6'}>
                    {socials.map((social, index) => (
                        <a
                            key={index}
                            href={social.linkUrl}
                            className={'border border-primary-white-101 flex items-center h-8 justify-center rounded-full w-8 sm:h-10 sm:w-10'}
                        >
                            <img src={social.imageSrc} alt={social.imageAlt} />
                        </a>
                    ))}
                </ul>
            </div>
            <div className={'space-y-4 sm:space-y-6'}>
                <p className={'font-bold text-xl'}>{data?.additional_services?.title}</p>
                <ul
                    className={
                        'leading-[28px] m-0 p-0 space-y-2 sm:space-y-4'
                    }
                >
                    {links.map((link, index) => (
                        <li
                            key={index}
                            className={'flex items-center gap-4 sm:gap-6'}
                        >
                            <a
                                href={link.href}
                                target="_blank"
                                rel="noreferrer"
                                className={'!no-underline'}
                            >
                                <span className={'text-white text-nowrap'}>
                                    {link.title}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={''}>
                <ul
                    className={
                        'leading-7 space-y-4 sm:space-y-6'
                    }
                >
                    {contacts.map((contact, index) => (
                        <li key={index} className={'flex gap-4 items-start sm:gap-6'}>
                            <a
                                href={contact.linkUrl}
                            >
                                <div className={'h-8 w-8 sm:h-10 sm:w-10'}>
                                    <img
                                        src={contact.imageSrc}
                                        alt={contact.imageAlt}
                                    />
                                </div>
                            </a>
                            <span className={'mt-1.5 text-justify text-sm sm:text-base sm:leading-8 md:w-[266px]'}>
                                {contact.description}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
